import React from 'react';
import styled from 'styled-components';
import { Pre } from '../atoms';
import { AutoMessageTitle } from '../atoms';
import { IDirection } from '../../interfaces/direction.interface';
import { ChatRight } from './ChatRight';
import { ChatLeft } from './ChatLeft';
import { IAutoMessage } from '../../interfaces/faq.interface';
import Linkify from 'linkify-it';
import { Parser } from 'simple-text-parser';
import { RoundedButton } from '../atoms/RoundedButton';
import { formatDate } from '../../utils/date';
import ClearFixStyle from '../atoms/ClearFixStyle';
import { AutoMessageBody } from '../atoms/AutoMessageBody';
import { RatClickTracker } from './RatClickTracker';
import { useRootStore } from '../../App';

const DateStyledDiv = styled.div`
  font-size: 12px;
  line-height: normal;
  color: #828282;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: right;padding-right: 2%;${ClearFixStyle}`
      : 'margin-top: 0px;text-align: left;'}
`;

const ExternalLinkButtonDiv = styled.div`
  max-width: 254px;
  button {
    &::after {
      content: '';
      background: url(/images/new_window_outline.png);
      background-size: cover;
      position: absolute;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      margin-top: 1px;
    }
  }
`;

const BaseStyledDiv = styled.div`
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  padding: ${(props: { isWide: boolean }) =>
    props.isWide ? '0 32px 8px' : '16px 16px 16px'};
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `word-wrap: break-word;`
      : `border-collapse: separate;
      border-radius: 16px;`}
`;

const AutoMessageStyledDiv = styled.div`
  overflow: hidden;
  ${(props: { isWide: boolean }) =>
    props.isWide ? 'margin: 0px 0 0px !important;' : 'word-break: break-all;'}
`;

interface Props {
  isWide: boolean;
  clickHandler: any;
  message: IAutoMessage;
  userId: string;
  childrenContainerDivRef?: React.RefObject<HTMLDivElement>;
  messageDivRef?: React.RefObject<HTMLDivElement>;
  addRefDivForAutoScroll: boolean;
}

export const AutoMessage = (props: Props) => {
  const root = useRootStore();
  const {
    isWide,
    clickHandler,
    message,
    userId,
    childrenContainerDivRef,
    messageDivRef,
    addRefDivForAutoScroll,
  } = props;

  const direction: IDirection =
    userId === message.messageSender ? 'outgoing' : 'incoming';

  // copied from ih-front
  const buttonStyle = {
    width: '100%',
    marginTop: '12px',
  };

  function generateAutoMessageBody() {
    const hasLinkTexts = message.messageBody
      ?.match(/\[.+?]\(.+?\)/g)
      ?.map((e) => {
        return e;
      });

    if (!hasLinkTexts) {
      return message.messageBody;
    } else {
      const parser = new Parser();

      hasLinkTexts.forEach((linkTextString) => {
        parser.addRule(linkTextString, () => {
          // linkTextString is pure string value like as [全国旅行支援クーポン](http://gototravel.rakuten.co.jp)
          // the Rule extracts link and text from the pure string and replace it with mix of String and JXS
          return `<a href=${
            Linkify().match(linkTextString)?.[0].url
          } target='_blank'>${linkTextString
            .match(/\[.+?]/)?.[0]
            .replace('[', '')
            .replace(']', '')}</a>`;
        });
      });
      return (
        <pre
          style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{
            __html: parser.render(message.messageBody),
          }}
        />
      );
    }
  }

  return direction === 'outgoing' ? (
    <>
      {addRefDivForAutoScroll && (
        <div ref={root.inquiryPageStore.autoMessageDivRefForScroll} />
      )}
      <ChatRight isWide={isWide}>
        <BaseStyledDiv
          isWide={isWide}
          style={{
            background: direction === 'outgoing' ? '#DCF3FF' : '',
          }}
        >
          <AutoMessageStyledDiv
            isWide={isWide}
            ref={childrenContainerDivRef}
            // style={{
            //   height: messageDivRef!.current
            //     ? messageDivRef!.current.offsetHeight + 'px'
            //     : '',
            //   transition: 'all 0.2s ease-in-out',
            // }}
          >
            <div ref={messageDivRef}>
              <Pre>{message.messageBody}</Pre>
            </div>
          </AutoMessageStyledDiv>
          {message.inquiryId && (
            <DateStyledDiv isWide={isWide}>
              {formatDate(message.messageSentTimestamp, 'YYYY/MM/DD HH:mm')}
            </DateStyledDiv>
          )}
        </BaseStyledDiv>
      </ChatRight>
    </>
  ) : (
    <ChatLeft isWide={isWide} image={'/images/bot_icon.png'}>
      <BaseStyledDiv isWide={isWide}>
        <AutoMessageStyledDiv
          isWide={isWide}
          ref={childrenContainerDivRef}
          // style={{
          //   height: messageDivRef!.current
          //     ? messageDivRef!.current.offsetHeight + 'px'
          //     : '',
          //   transition: 'all 0.2s ease-in-out',
          // }}
        >
          <AutoMessageTitle>自動応答</AutoMessageTitle>
          <AutoMessageBody>{generateAutoMessageBody()}</AutoMessageBody>
          <RatClickTracker componentId={'faq_option'}>
            {message.option?.map((e, index) => (
              <RoundedButton
                disabled={e.isAlreadySelectedOption}
                style={buttonStyle}
                key={`auto-message-option-${index}`}
                onClick={() => clickHandler(message.messageSentTimestamp, e)}
                isSharpBorder={true}
                isLeftAlign={true}
              >
                {e.value}
              </RoundedButton>
            ))}
            {message.linkTo?.map((e, index) => (
              <ExternalLinkButtonDiv key={`auto-message-link-${index}`}>
                <RoundedButton
                  style={buttonStyle}
                  onClick={() => {
                    window.open(e.href, '_blank');
                  }}
                >
                  {e.text}
                </RoundedButton>
              </ExternalLinkButtonDiv>
            ))}
          </RatClickTracker>
        </AutoMessageStyledDiv>
      </BaseStyledDiv>
    </ChatLeft>
  );
};
